import { EАctiveTabActionTypes } from '../../actions/activeTab/types';
import { IActiveTab } from '../../types/activeTab';
import { ETabType } from '../../types/filters';
import { TReduxActions } from '../../types/redux';

export const initialState = {
  activeTab: null,
  isInitialized: false,
};

export const activeTabReducer = (state: IActiveTab = initialState, action: TReduxActions): IActiveTab => {
  switch (action.type) {
    case EАctiveTabActionTypes.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload.activeTab,
        isInitialized: action.payload.isInitialized,
      };

    case EАctiveTabActionTypes.INITIALIZE_FROM_URL:
      return {
        ...state,
        activeTab: action.payload.activeTab || ETabType.Аdvertisements,
        isInitialized: true,
      };

    default:
      return state;
  }
};
